export const monsPathsToForcePageDirection = [
  '/abis/index.html',
  'abis/listing',
  '/productclassify',
  '/productclassify-devo',
];
